module.exports = __webpack_public_path__ + "img/Promena-white.7d1c65a6.png";